import apiClient from "./apiClient";

const PodsService = {
    getPODsByTraceId: (traceId: string) => {
        return apiClient.get(`api/v1/address-pods/${traceId}`);
    },
};

export default PodsService;
